import * as actions from './Actions'
import * as overpanelActions from './overpanels'
import * as payRequestActions from './pay-request'
import * as sendActions from './send'
import { post } from '../../calculator/lib/xhr'
import { ActionTypes as types } from '../constants'
import * as travelRuleUtils from '../utils/travelRuleUtils'
import * as addCardUtils from '../utils/addCardUtils'

export function changeCardNumber(cardNumber, cardSpec) {
  return {
    type: types.TRANSACTION.CHANGE_CARD_NUMBER,
    data: { cardNumber, cardSpec },
  }
}

export function changeExpiry(expiry) {
  return {
    type: types.TRANSACTION.CHANGE_EXPIRY,
    data: { expiry },
  }
}

export function changeCardSecurityCode(securityCode) {
  return {
    type: types.TRANSACTION.CHANGE_SECURITY_CODE,
    data: { securityCode },
  }
}

export function changeCardType(cardType) {
  return {
    type: types.TRANSACTION.CHANGE_CARD_TYPE,
    data: { cardType },
  }
}

export function handleSaveCard() {
  return (dispatch, getState) => {
    // grab data from the store to check whether we have all info to proceed
    const {
      card,
      card: {
        cardSpec: { fields },
      },
      user: { birthYear, birthMonth, birthDay },
    } = getState()

    // if we needed DOB but do not have valid DOB, return out
    if (
      fields.dob &&
      !travelRuleUtils.isDOBValid(birthYear, birthMonth, birthDay)
    ) {
      return
    }

    // if we do not have all other necessary fields, return out
    if (addCardUtils.getAddCardIncompleteRequiredFields({ ...card }).length) {
      return
    }

    // if not valid card number, return out
    // This extra check is added due to user selected card type cases
    // not validating properly (HTML DOM validation only checks pattern prop)
    if (!addCardUtils.cardNumberIsValid(card)) {
      return
    }

    // else continue with saving card
    dispatch(saveCard())
  }
}

export function saveCard() {
  return (dispatch, getState) => {
    dispatch({ type: types.TRANSACTION.ADD_CARD })

    // grab necessary data from the store
    const {
      card: {
        cardSpec: { type: cardType },
        cardNumber: ccNum,
        expiry,
        securityCode,
      },
      address: {
        selectedBillingAddress: { id: billingAddressId },
      },
      user: { birthYear: dobYear, birthMonth: dobMonth, birthDay: dobDay },
      server: { requestId, isFBMessenger, idpConnect },
    } = getState()

    // massage expiration date data into correct format
    const expirationMonth = expiry.slice(0, 2)
    let expirationYear = expiry.slice(3)
    expirationYear =
      expirationYear.length === 4 ? expirationYear : `20${expirationYear}`

    const payload = {
      creditOrDebit: 'credit',
      cardType,
      ccNum,
      expirationMonth,
      expirationYear,
      securityCode,
      billingAddressId,
      dobYear,
      dobMonth,
      dobDay,
    }

    post('/myaccount/transfer/cards', payload)
      .then((response = {}) => {
        dispatch(addedCard(response))
        if (isFBMessenger) {
          return dispatch(successFbAddCard())
        }

        if (idpConnect.intent === 'idpConnect') {
          dispatch(successFbAddCard())
          window.location = idpConnect.successRedirect
          return
        }

        // maybe close when everything is done?
        dispatch(overpanelActions.toggleAddCardOverpanel({ show: false }))

        if (requestId) {
          dispatch(payRequestActions.fetchFundingOptions())
        } else {
          dispatch(sendActions.fetchFundingOptions())
        }
      })
      .catch(actions.handleError(dispatch))
  }
}

export function addedCard(response) {
  const { CREDIT: { cardType, lastDigits } = {} } = response
  return {
    type: types.TRANSACTION.ADDED_CARD,
    data: {
      addedCard: { cardType, lastDigits },
    },
  }
}

export function successFbAddCard() {
  return {
    type: types.TRANSACTION.SUCCESS_FB_ADD_CARD,
    data: {
      cardAdded: true,
    },
  }
}

export function handleNoBillingAddress(shakeBillingLabel) {
  return {
    type: types.ADDRESS.NO_BILLING_ADDRESS,
    shakeBillingLabel: !shakeBillingLabel,
  }
}
